import { t } from 'i18next';
import { z } from 'zod';

import { zu } from '@/lib/zod/zod-utils';

export const zFormFieldsEmailFilter = () =>
  z.object({
    email: zu.string.emailOptional(z.string(), {
      invalid_type_error: t('auth:users.data.email.invalid'),
    }),
  });
export type FormFieldsEmailFilters = z.infer<
  ReturnType<typeof zFormFieldsEmailFilter>
>;
